"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MILES = exports.YARDS = exports.FEET = exports.INCHES = exports.KILOMETRES = exports.METRES = exports.CENTIMETRES = exports.MILLIMETRES = exports.IMPERIAL_SYSTEM = exports.METRIC_SYSTEM = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _aliases;

var METRIC_SYSTEM = 'metric';
exports.METRIC_SYSTEM = METRIC_SYSTEM;
var IMPERIAL_SYSTEM = 'imperial';
exports.IMPERIAL_SYSTEM = IMPERIAL_SYSTEM;
var MILLIMETRES = ['mm', 'milimetres', 'milimetre', 'milimeters', 'milimeter'];
exports.MILLIMETRES = MILLIMETRES;
var CENTIMETRES = ['cm', 'centimetres', 'centimetre', 'centimeters', 'centimeter'];
exports.CENTIMETRES = CENTIMETRES;
var METRES = ['m', 'metres', 'metre', 'meters', 'meter'];
exports.METRES = METRES;
var KILOMETRES = ['km', 'kilometres', 'kilometre', 'kilometers', 'kilometer'];
exports.KILOMETRES = KILOMETRES;
var INCHES = ['in', 'inch', 'inches'];
exports.INCHES = INCHES;
var FEET = ['ft', 'feet', 'foot', 'feets', 'foots'];
exports.FEET = FEET;
var YARDS = ['yd', 'yard', 'yards'];
exports.YARDS = YARDS;
var MILES = ['mi', 'mile', 'miles'];
exports.MILES = MILES;

var getAlias = function getAlias(values) {
  return "<".concat(values.join('>|<'), ">");
};

var aliases = (_aliases = {}, (0, _defineProperty2["default"])(_aliases, getAlias(MILLIMETRES), {
  name: 'millimetres'
}), (0, _defineProperty2["default"])(_aliases, getAlias(CENTIMETRES), {
  name: 'centimetres'
}), (0, _defineProperty2["default"])(_aliases, getAlias(METRES), {
  name: 'metres'
}), (0, _defineProperty2["default"])(_aliases, getAlias(KILOMETRES), {
  name: 'kilometres'
}), (0, _defineProperty2["default"])(_aliases, getAlias(INCHES), {
  name: 'inches'
}), (0, _defineProperty2["default"])(_aliases, getAlias(FEET), {
  name: 'feet'
}), (0, _defineProperty2["default"])(_aliases, getAlias(YARDS), {
  name: 'yards'
}), (0, _defineProperty2["default"])(_aliases, getAlias(MILES), {
  name: 'miles'
}), _aliases);

var checkAliases = function checkAliases(unitName) {
  var unitActualName;
  Object.keys(aliases).forEach(function (key) {
    if (key.indexOf("<".concat(unitName, ">")) >= 0) {
      unitActualName = aliases[key].name;
    }
  });
  return unitActualName;
};

var convertToMetres = function convertToMetres(value, unit) {
  switch (unit) {
    case 'millimetres':
      return value * 0.001;

    case 'centimetres':
      return value * 0.01;

    case 'kilometres':
      return value * 1000;

    case 'inches':
      return value * (1 / 39.370079);

    case 'feet':
      return value * (1 / 3.28084);

    case 'yards':
      return value * (1 / 1.093613);

    case 'miles':
      return value * (1 / 0.000621371);

    default:
      return value;
  }
};

var convertToUnit = function convertToUnit(value, unit) {
  switch (unit) {
    case 'millimetres':
      return value * 1000;

    case 'centimetres':
      return value * 100;

    case 'kilometres':
      return value / 1000;

    case 'inches':
      return value * 39.370079;

    case 'feet':
      return value * 3.28084;

    case 'yards':
      return value * 1.093613;

    case 'miles':
      return value * 0.000621371;

    default:
      return value;
  }
};

var round = function round(value, decimals) {
  return Number("".concat(Math.round("".concat(value, "e").concat(decimals)), "e-").concat(decimals));
};

var conversions = function conversions(value, fromUnit, toUnit) {
  var inputValue = typeof value === 'string' ? parseFloat(value) : value;
  var from = checkAliases(fromUnit);
  var to = checkAliases(toUnit);
  if (!inputValue) throw new Error('Missing value to convert!');
  if (!from || !to) throw new Error('Unit/Alias not currently supported!');
  return round(convertToUnit(convertToMetres(inputValue, from), to), 6);
};

var _default = conversions;
exports["default"] = _default;
//# sourceMappingURL=conversions.js.map